import { handleUtagEvent } from '../../../core/js/actions/initialActions';

import { debug, warn } from '../../../core/js/utils/logger';

module.exports = /* @ngInject */
(
    ReduxService
) => {
    return {
        setGaLinkTrack(gaAction, gaLabel) {
            ReduxService.getStore()
                .then((store) => {
                    const linkData = {
                        event_category: 'registry',
                        event_action: gaAction,
                        event_label: gaLabel
                    };

                    store.dispatch(handleUtagEvent(linkData, 'link'));
                });
        },

        /**
         * Update the Tealium UDO model with a new page_id
         * that is found by a Contentful slug key
         * @param {String} slug     Contentful slug
         * @return {Object}         $q promise fulfilled with the page_id
         */
        setUtagPageId(slug) {
            return ReduxService.getState()
                .then((state) => {
                    const pageId = state.core.localizations.containers.analyticsContainer[slug];

                    if (pageId) {
                        ReduxService.getStore()
                            .then((store) => {
                                // eslint-disable-next-line camelcase
                                store.dispatch(handleUtagEvent({ page_id: pageId }, 'view'));
                            });
                    } else {
                        warn(`No page_id found for slug ${slug}`);
                    }

                    return pageId;
                });
        },

        setCustomUtagEvent(utagData) {
            ReduxService.getStore()
                .then((store) => {
                    store.dispatch(handleUtagEvent(utagData, 'link'));
                });
        }
    };
};
